/**
 * 所有类的基类
 */
export default class Clazz {
    /**
     * 构造函数
     * @param  {object}    options 可选参数
     * @return {undefined}
     */
    constructor(options) {
        this.setOptions(options);
    }

    /**
     * 设置可选参数
     * @param  {object}    options 可选参数
     * @return {undefined}
     */
    setOptions(options) {
        this.options = Object.assign({}, this.options, options);
    }

    /**
     * 根据键值删除可选参数
     * @param {String} key 键值
     * @return {undefined}
     */
    removeOption(key) {
        if (this.options && key in this.options) {
            delete this.options[key];
        }
    }

    /**
     * 清空可选参数
     * @return {undefined}
     */
    clearOptions() {
        this.options = {};
    }

    /**
     * 判断一个数据对象是否为数据模型对象
     * @param  {object}    obj 数据对象
     * @return {boolean}       是否为模型对象
     */
    static is(obj) {
        return obj && obj instanceof this;
    }
}
